import { SET_DRAGGING, SET_DRAGGED_ITEM } from 'FormsUI/actions/DragState.ts';
const INITIAL_STATE = {
  isDragging: false,
  draggedItem: null
};
export function dragState(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_DRAGGING:
      {
        return Object.assign({}, state, {
          isDragging: action.isDragging
        });
      }
    case SET_DRAGGED_ITEM:
      {
        return Object.assign({}, state, {
          draggedItem: action.item
        });
      }
    default:
      return state;
  }
}